export default __webpack_public_path__ + "images/hipages-logo-small.dd7e8f0e06dc2bd0b842c38792a361f5.svg";